import { render, staticRenderFns } from "./Phonelist.vue?vue&type=template&id=67f954cc&scoped=true&"
import script from "./Phonelist.vue?vue&type=script&lang=js&"
export * from "./Phonelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f954cc",
  null
  
)

export default component.exports